import cfJS from "../Engine/cfJS";
import engine from "../Engine/Engine";

class CurrentUser {

    constructor(host) {
        this.host = host || location.origin;
    }

    fentchUser() {
        return new Promise((resolve, reject) => {
            engine.postRequest(`${this.host}/api/get-user`, null, (response)=>{
                let data = null;
                try {
                    data = JSON.parse(response);
                }
                catch(e) {
                    console.log(e);
                }
                if(data.result !== "success"){
                    reject();
                }
                resolve(data);
            });
        });
    }
}

window.CurrentUser = CurrentUser;
export default CurrentUser;